export default class Pagination {
    constructor() {
        this.getPaginationStartIndex = () => {
            this.startPaginationIndex = (this.currentPage - 1) * this.totalPageSize;
        };
        this.getPaginationLastIndex = () => {
            const end = this.startPaginationIndex + this.totalPageSize >= this.totalPage
                ? undefined
                : this.startPaginationIndex + this.totalPageSize;
            this.endPaginationIndex = end ? end : this.totalPage;
        };
        this.handleCurrentPageChange = (newPage) => {
            this.currentPage = newPage;
            this.getPaginationStartIndex();
            this.getPaginationLastIndex();
        };
        this.currentPage = 1;
        this.totalPageSize = 10;
        this.totalPage = 0;
        this.startPaginationIndex = -1;
        this.endPaginationIndex = 0;
    }
}
